import Vue from 'vue';
import Vuex from 'vuex';
import VueLog from '@dreipol/vue-log';
import VueSnip from 'vue-snip';
import VueObserveVisibility from 'vue-observe-visibility';

import initVuex from 'framework/vuex';
import registry from './registry';
import vueLogConfig from './vue-log-config';
import theEgg from '../../util/misc/the-egg';

/**
 * Create and mount a new component
 * @param {HTMLElement} node - The node
 * @param {object} store - Vuex store instance
 */
function mountComponent(node, store = null) {
    const name = node.getAttribute('is');
    const Component = store ? new Vue({ name, store }) : new Vue({ name });

    Component.$mount(node);
}

/**
 * Bootstrap the vue root instance
 * @return {Promise} A promise returning when the registry has loaded all components and the app was initialized
 */
export function init() {
    // NOTE: Plugin initialisation is run before registry because new merge strategies might be applied by plugins.
    Vue.use(Vuex);
    Vue.use(VueLog, vueLogConfig);
    Vue.use(VueSnip);
    Vue.use(VueObserveVisibility);

    const store = initVuex();
    // handle the easter egg
    theEgg();

    return registry().then(() => {
        // Instantiate all vue instances on this page
        const nodes = document.querySelectorAll('component[is]');
        Array.from(nodes).forEach(node => mountComponent(node, store));
    });
}

export function reinitVueComponents(entryNode) {
    const nodes = entryNode.querySelectorAll('component[is]');
    Array.from(nodes).forEach(node => mountComponent(node));
}
